import { selectClientName } from '../common/utils';

export const brandVars = {
  bancaliv: {
    gq: 'https://bk.bancaliv.com/graphql',
    bk: 'https://bk.bancaliv.com/',
    app: 'https://app.bancaliv.com/',
    sales: 'https://sales.bancaliv.com',
    bt: 'bubancaliv',
    ossado: 'https://ossado.bancaliv.com',
    admin: 'https://portal.bancaliv.com/',
  },
  credipress: {
    gq: 'https://bk.credipress.com/graphql',
    bk: 'https://bk.credipress.com/',
    app: 'https://app.credipress.com/',
    sales: 'https://sales.credipress.com',
    bt: 'bucredipress',
    ossado: 'https://ossado.credipress.com',
    admin: 'https://portal.credipress.com/',
  },
  fie: {
    gq: 'https://bk.fie.com.co/graphql',
    bk: 'https://bk.fie.com.co/',
    app: 'https://app.fie.com.co/',
    sales: 'https://sales.fie.com.co',
    bt: 'bufie',
    admin: 'https://portal2.fie.com.co/',
  },
  gym: {
    gq: 'https://bk.gmserviciosfinancieros.com.co/graphql',
    bk: 'https://bk.gmserviciosfinancieros.com.co/',
    app: 'https://app.gmserviciosfinancieros.com.co/',
    sales: 'https://sales.gmserviciosfinancieros.com.co',
    bt: 'bugym',
    admin: 'https://admin.gmserviciosfinancieros.com.co/',
  },
  tusolucion: {
    gq: 'https://bk.tusolucion.com.co/graphql',
    bk: 'https://bk.tusolucion.com.co/',
    app: 'https://app.tusolucion.com.co/',
    sales: 'https://sales.tusolucion.com.co',
    bt: 'buttusolucion',
    admin: 'https://portal.tusolucion.com.co/',
  },
  finnvo: {
    gq: 'https://bk.finnvo.co/graphql',
    bk: 'https://bk.finnvo.co/',
    app: 'https://app.finnvo.co/',
    sales: 'https://sales.finnvo.co',
    bt: 'bufinnvo',
    ossado: 'https://ossado.finnvo.co',
    admin: 'https://portal.finnvo.co/',
  },
  fibanca: {
    gq: 'https://bk.fibanca.co/graphql',
    bk: 'https://bk.fibanca.co/',
    app: 'https://app.fibanca.co/',
    sales: 'https://sales.fibanca.co',
    bt: 'bufibanca',
    ossado: 'https://ossado.fibanca.co',
    admin: 'https://portal.fibanca.co/',
  },
  creditoo: {
    gq: 'https://backend.miliv2.com:4071/graphql',
    bk: 'https://backend.miliv2.com:4071/',
    app: 'https://app.creditoo.com.co/',
    sales: 'https://sales.creditoo.com.co',
    bt: 'bucreditoo',
    admin: 'https://admin.creditoo.com.co/',
  },
  inversiones: {
    gq: 'https://bk.inversiones.com.co/graphql',
    bk: 'https://bk.inversiones.com.co/',
    app: 'https://app.inversiones.com.co/',
    sales: 'https://sales.inversiones.com.co',
    bt: 'buinversiones',
    ossado: 'https://ossado.inversiones.com.co',
    admin: 'https://admin.inversiones.com.co/',
  },
  nauw: {
    gq: 'https://bk.nauwcolombia.com/graphql',
    bk: 'https://bk.nauwcolombia.com/',
    app: 'https://app.nauw.com.co/',
    sales: 'https://sales.nauw.com.co',
    bt: 'bunauw',
    ossado: 'https://ossado.nauwcolombia.com',
    admin: 'https://portal.nauwcolombia.com/',
  },
  liberate: {
    gq: 'https://bk.liberateco.online/graphql',
    bk: 'https://bk.liberateco.online/',
    app: 'https://liberateco.online/',
    sales: 'https://sales.liberateco.online',
    bt: 'buliberate',
    ossado: 'https://ossado.liberateco.online',
    admin: 'https://portal.liberateco.online/',
  },
  lenddi: {
    gq: 'https://bk.lenddi.co/graphql',
    bk: 'https://bk.lenddi.co/',
    app: 'https://app.lenddi.co/',
    sales: 'https://sales.lenddi.co',
    bt: 'bulenddi',
    ossado: 'https://ossado.lenddi.co',
    admin: 'https://admin.lenddi.co/',
  },
  freend: {
    gq: 'https://bk.freend.co/graphql',
    bk: 'https://bk.freend.co/',
    app: 'https://app.freend.co/',
    sales: 'https://sales.freend.co',
    bt: 'bufreend',
    ossado: 'https://ossado.freend.co',
    admin: 'https://portal.freend.co/',
  },
  mili: {
    gq: 'https://backqa.mili.com.co/graphql',
    bk: 'https://backqa.mili.com.co/',
    app: 'https://appqa.mili.com.co/',
    sales: 'https://salesqa.mili.com.co',
    bt: 'buwow',
    ossado: 'https://ossado.bancaliv.com',
    admin: 'https://qa.mili.com.co/',
    epaycoTest: true,
  },
  credinver: {
    gq: 'https://bk.credinver.com.co/graphql',
    bk: 'https://bk.credinver.com.co/',
    app: 'https://app.credinver.com.co',
    sales: 'https://sales.credinver.com.co',
    bt: 'bucredinver',
    ossado: 'https://ossado.credinver.com.co',
    admin: 'https://portal.credinver.com.co',
  },
  maxcredit: {
    gq: 'https://bk.maxcredit.com.co/graphql',
    bk: 'https://bk.maxcredit.com.co/',
    app: 'https://app.maxcredit.com.co/',
    sales: 'https://sales.maxcredit.com.co',
    bt: 'bumaxcredit',
    ossado: 'https://ossado.maxcredit.com.co',
    admin: 'https://portal.maxcredit.com.co',
  },
  fondo: {
    gq: 'https://fbk.elbancodelagente.co/graphql',
    bk: 'https://fbk.elbancodelagente.co/',
    app: '',
    sales: 'https://sales.elbancodelagente.co',
    bt: 'bufondocredito',
    admin: 'https://portal.elbancodelagente.co/',
  },
  sofi: {
    gq: 'https://bk.sofi.com.co/graphql',
    bk: 'https://bk.sofi.com.co/',
    app: 'https://app.sofi.com.co/',
    sales: 'https://sales.sofi.com.co',
    bt: 'busofi',
  },
  zali: {
    gq: 'https://bk.zali.com.co/graphql',
    bk: 'https://bk.zali.com.co/',
    app: 'https://app.zali.com.co/',
    sales: 'https://sales.zali.com.co',
    bt: 'buzali',
    ossado: 'https://ossado.zali.com.co',
    admin: 'https://portal.zali.com.co',
  },
  libramoneda: {
    gq: 'https://bk.libramoneda.com/graphql',
    bk: 'https://bk.libramoneda.com/',
    app: 'https://app.libramoneda.com/',
    sales: 'https://sales.libramoneda.com',
    bt: 'bulibramoneda',
    ossado: 'https://ossado.libramoneda.com',
    admin: 'https://portal.libramoneda.com',
  },
  quickbank: {
    gq: 'https://bk.qbcol.com.co/graphql',
    bk: 'https://bk.qbcol.com.co/',
    app: 'https://app.qbcol.com.co/',
    sales: 'https://sales.qbcol.com.co',
    bt: 'buquickbank',
    ossado: 'https://ossado.qbcol.com.co',
    admin: 'https://portal.qbcol.com.co',
  },
  finanzas: {
    gq: 'https://bk.finanzas360.co/graphql',
    bk: 'https://bk.finanzas360.co/',
    app: 'https://app.finanzas360.co/',
    sales: 'https://sales.finanzas360.co',
    bt: 'bufinanzas',
    ossado: 'https://ossado.finanzas360.co',
    admin: 'https://portal.finanzas360.co',
  },
  fembisol: {
    gq: 'https://bk.fembisol.mili.com.co/graphql',
    bk: 'https://bk.fembisol.mili.com.co/',
    app: 'https://app.fembisol.mili.com.co/',
    sales: 'https://sales.fembisol.mili.com.co',
    bt: 'bufembisol',
    ossado: 'https://ossado.fembisol.mili.com.co',
    admin: 'https://fembisol.mili.com.co',
  },
  suvalor: {
    gq: 'https://back.suvalorsufuturo.com/graphql',
    bk: 'https://back.suvalorsufuturo.com/',
    app: 'https://app.suvalorsufuturo.com/',
    sales: 'https://sales.suvalorsufuturo.com',
    bt: 'busuvalor',
    ossado: 'https://ossado.suvalorsufuturo.com',
    admin: 'https://portal.suvalorsufuturo.com',
  },
  crecevalor: {
    gq: 'https://back.crecevalor.com/graphql',
    bk: 'https://back.crecevalor.com/',
    app: 'https://app.crecevalor.com/',
    sales: 'https://sales.crecevalor.com',
    bt: 'bucrecevalor',
    ossado: 'https://ossado.crecevalor.com',
    admin: 'https://portal.crecevalor.com',
  },
  mifianza: {
    gq: 'https://back.mifianza.online/graphql',
    bk: 'https://back.mifianza.online/',
    app: 'https://app.mifianza.online/',
    sales: 'https://sales.mifianza.online',
    bt: 'bumifianza',
    admin: 'https://portal.mifianza.online',
  },
  finzap: {
    gq: 'https://bk.finzap.com.co/graphql',
    bk: 'https://bk.finzap.com.co/',
    app: 'https://app.finzap.com.co/',
    sales: 'https://sales.finzap.com.co',
    bt: 'bufinzap',
    ossado: 'https://ossado.finzap.com.co',
    admin: 'https://portal.finzap.com.co',
  },
  procord: {
    gq: 'https://bk.procord.com.co/graphql',
    bk: 'https://bk.procord.com.co/',
    app: 'https://app.procord.com.co/',
    sales: 'https://sales.procord.com.co',
    bt: 'buprocord',
    ossado: 'https://ossado.procord.com.co',
    admin: 'https://portal.procord.com.co',
  },
  resuelveya: {
    gq: 'https://bk.resuelveya.co/graphql',
    bk: 'https://bk.resuelveya.co/',
    app: 'https://app.resuelveya.co/',
    sales: 'https://sales.resuelveya.co',
    bt: 'buresuelveya',
    ossado: 'https://ossado.resuelveya.co',
    admin: 'https://portal.resuelveya.co',
  },
  socialcredit: {
    gq: 'https://bk.socialcredit.com.co/graphql',
    bk: 'https://bk.socialcredit.com.co/',
    app: 'https://app.socialcredit.com.co/',
    sales: 'https://sales.socialcredit.com.co',
    bt: 'busocialcredit',
    ossado: 'https://ossado.socialcredit.com.co',
    admin: 'https://portal.socialcredit.com.co',
  },
  cxc: {
    gq: 'https://bk.cxc.com.co/graphql',
    bk: 'https://bk.cxc.com.co/',
    app: 'https://app.cxc.com.co/',
    sales: 'https://sales.cxc.com.co',
    bt: 'bucxc',
    admin: 'https://portal.cxc.com.co',
  },
  banvi: {
    gq: 'https://bk.banvi.com.co/graphql',
    bk: 'https://bk.banvi.com.co/',
    app: 'https://app.banvi.com.co/',
    sales: 'https://sales.banvi.com.co',
    bt: 'bubanvi',
    ossado: 'https://ossado.banvi.com.co',
    admin: 'https://portal.banvi.com.co',
  },
  hazloya: {
    gq: 'https://bk.hazloya.com.co/graphql',
    bk: 'https://bk.hazloya.com.co/',
    app: 'https://app.hazloya.com.co/',
    sales: 'https://sales.hazloya.com.co',
    bt: 'buhazloya',
    ossado: 'https://ossado.hazloya.com.co',
    admin: 'https://portal.hazloya.com.co',
  },
  pys: {
    gq: 'https://bk.pyssolucionesfinancieras.com/graphql',
    bk: 'https://bk.pyssolucionesfinancieras.com/',
    app: 'https://app.pyssolucionesfinancieras.com/',
    sales: 'https://sales.pyssolucionesfinancieras.com',
    bt: 'bupys',
    ossado: 'https://ossado.pyssolucionesfinancieras.com',
    admin: 'https://portal.pyssolucionesfinancieras.com',
  },
  netwifi: {
    gq: 'https://bk.thenetwifi.com/graphql',
    bk: 'https://bk.thenetwifi.com/',
    app: 'https://app.thenetwifi.com/',
    sales: 'https://sales.thenetwifi.com',
    bt: 'bunetwifi',
    ossado: 'https://ossado.thenetwifi.com',
    admin: 'https://portal.thenetwifi.com',
  },
  credyfast: {
    gq: 'https://bk.credyfast.co/graphql',
    bk: 'https://bk.credyfast.co/',
    app: 'https://app.credyfast.co/',
    sales: 'https://sales.credyfast.co',
    bt: 'bucredyfast',
    ossado: 'https://ossado.credyfast.co',
    admin: 'https://portal.credyfast.co',
  },
  valit: {
    gq: 'https://bk.valit.co.com/graphql',
    bk: 'https://bk.valit.co.com/',
    app: 'https://app.valit.co.com/',
    sales: 'https://sales.valit.co.com',
    bt: 'buvalit',
    ossado: 'https://ossado.valit.co.com',
    admin: 'https://portal.valit.co.com',
  },
  oportunidades: {
    gq: 'https://bk.oportunidades.com.co/graphql',
    bk: 'https://bk.oportunidades.com.co/',
    app: 'https://app.oportunidades.com.co/',
    sales: 'https://sales.oportunidades.com.co',
    bt: 'buoportunidades',
    ossado: 'https://ossado.oportunidades.com.co',
    admin: 'https://portal.oportunidades.com.co',
  },
  meloncash: {
    gq: 'https://bk.meloncash.com.co/graphql',
    bk: 'https://bk.meloncash.com.co/',
    app: 'https://app.meloncash.com.co/',
    sales: 'https://sales.meloncash.com.co',
    bt: 'bumeloncash',
    ossado: 'https://ossado.meloncash.com.co',
    admin: 'https://portal.meloncash.com.co',
  },
  trufi: {
    gq: 'https://bk.trufi.com.co/graphql',
    bk: 'https://bk.trufi.com.co/',
    app: 'https://app.trufi.com.co/',
    sales: 'https://sales.trufi.com.co',
    bt: 'butrufi',
    ossado: 'https://ossado.trufi.com.co',
    admin: 'https://portal.trufi.com.co',
  },
  finanz: {
    gq: 'https://bk.finanzsas.online/graphql',
    bk: 'https://bk.finanzsas.online/',
    app: 'https://app.finanzsas.online/',
    sales: 'https://sales.finanzsas.online',
    bt: 'bufinanz',
    ossado: 'https://ossado.finanzsas.online',
    admin: 'https://portal.finanzsas.online',
  },
  logicash: {
    gq: 'https://bk.logicash.co/graphql',
    bk: 'https://bk.logicash.co/',
    app: 'https://app.logicash.co/',
    sales: 'https://sales.logicash.co',
    bt: 'bulogicash',
    admin: 'https://portal.logicash.co/',
  },
  krennova: {
    gq: 'https://bk.krennova.com.co/graphql',
    bk: 'https://bk.krennova.com.co/',
    app: 'https://app.krennova.com.co/',
    sales: 'https://sales.krennova.com.co',
    bt: 'bukrennova',
    admin: 'https://portal.krennova.com.co/',
  },
};

const brandsQA = {
  miliuat: {
    gq: 'https://uatbk.mili.com.co/graphql',
    bk: 'https://uatbk.mili.com.co/',
    app: 'https://demoapp.mili.com.co/',
    sales: 'https://demosales.mili.com.co',
    bt: 'buwow',
    ossado: 'https://ossado.mili.com',
    admin: 'https://uat.mili.com.co/',
    epaycoTest: true,
  },
  miliqa: {
    gq: 'https://demobak.mili.com.co/graphql',
    bk: 'https://demobak.mili.com.co/',
    app: 'https://demoapp.mili.com.co/',
    sales: 'https://sales.mili.com.co',
    bt: 'buwow',
    ossado: 'https://ossado.mili.com',
    admin: 'https://demo.mili.com.co/',
    epaycoTest: true,
  },
  local: {
    gq: 'http://localhost:4000/graphql',
    bk: 'http://localhost:4000/',
    app: 'http://localhost:19006/',
    sales: 'https://sales.mili.com.co',
    bt: 'buwow',
    ossado: 'http://localhost:8000',
  },
};

export function brandUrls(): {
  gq: string;
  bk: string;
  app: string;
  sales: string;
  bt: string;
  ossado?: string;
  admin?: string;
  epaycoTest?: boolean;
} {
  const client = selectClientName();

  if (client === 'bancaliv') {
    return brandVars.bancaliv;
  }
  if (client === 'mifianza') {
    return brandVars.mifianza;
  }
  if (client === 'finanz') {
    return brandVars.finanz;
  }
  if (client === 'procord') {
    return brandVars.procord;
  }
  if (client === 'resuelveya') {
    return brandVars.resuelveya;
  }
  if (client === 'finzap') {
    return brandVars.finzap;
  }
  if (client === 'fembisol') {
    return brandVars.fembisol;
  }
  if (client === 'credipress') {
    return brandVars.credipress;
  }
  if (client === 'fie') {
    return brandVars.fie;
  }
  if (client === 'gym') {
    return brandVars.gym;
  }
  if (client === 'fondo') {
    return brandVars.fondo;
  }
  if (client === 'tusolucion') {
    return brandVars.tusolucion;
  }
  if (client === 'finnvo') {
    return brandVars.finnvo;
  }
  if (client === 'creditoo') {
    return brandVars.creditoo;
  }
  if (client === 'inversiones') {
    return brandVars.inversiones;
  }
  if (client === 'nauw') {
    return brandVars.nauw;
  }
  if (client === 'fibanca') {
    return brandVars.fibanca;
  }
  if (client === 'liberate') {
    return brandVars.liberate;
  }
  if (client === 'lenddi') {
    return brandVars.lenddi;
  }
  if (client === 'credinver') {
    return brandVars.credinver;
  }
  if (client === 'freend') {
    return brandVars.freend;
  }
  if (client === 'maxcredit') {
    return brandVars.maxcredit;
  }
  if (client === 'sofi') {
    return brandVars.sofi;
  }
  if (client === 'zali') {
    return brandVars.zali;
  }
  if (client === 'libramoneda') {
    return brandVars.libramoneda;
  }
  if (client === 'quickbank') {
    return brandVars.quickbank;
  }
  if (client === 'finanzas') {
    return brandVars.finanzas;
  }
  if (client === 'suvalor') {
    return brandVars.suvalor;
  }
  if (client === 'crecevalor') {
    return brandVars.crecevalor;
  }
  if (client === 'socialcredit') {
    return brandVars.socialcredit;
  }
  if (client === 'cxc') {
    return brandVars.cxc;
  }
  if (client === 'banvi') {
    return brandVars.banvi;
  }
  if (client === 'hazloya') {
    return brandVars.hazloya;
  }
  if (client === 'pys') {
    return brandVars.pys;
  }
  if (client === 'netwifi') {
    return brandVars.netwifi;
  }
  if (client === 'credyfast') {
    return brandVars.credyfast;
  }
  if (client === 'valit') {
    return brandVars.valit;
  }
  if (client === 'oportunidades') {
    return brandVars.oportunidades;
  }
  if (client === 'meloncash') {
    return brandVars.meloncash;
  }
  if (client === 'trufi') {
    return brandVars.trufi;
  }
  if (client === 'logicash') {
    return brandVars.logicash;
  }
  if (client === 'krennova') {
    return brandVars.krennova;
  }
  if (client === 'local') {
    return brandsQA.local;
  }
  if (client === 'miliqa') {
    return brandsQA.miliqa;
  }
  if (client === 'miliuat') {
    return brandsQA.miliuat;
  }

  return brandVars.mili;
}
